var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "1288.1 1265.82 1423.69 1468.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#17478f;}.cls-2{fill:#0ea7d6;fill-rule:evenodd;}.cls-3{fill:#ccc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2328.94,2555.6A144.18,144.18,0,0,0,2125,2351.71a321.32,321.32,0,0,1-454.42-454.42,144.18,144.18,0,0,0-203.89-203.9c-119.06,119.06-178.59,275.09-178.59,431.11s59.53,312.05,178.59,431.1,275.08,178.59,431.1,178.59S2209.88,2674.66,2328.94,2555.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1837.87,1980.52a144.18,144.18,0,1,0,203.9,203.9L2245.18,1981l220.57,220.56a144.17,144.17,0,0,0,203.89-203.89l-321.47-321.46-1-1.07a144.19,144.19,0,0,0-203.92,0v0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1787.22,1319.17c71.15-71.14,186.51-71.14,257.66,0s71.14,186.51,0,257.65a182.19,182.19,0,0,1-257.66,0C1716.08,1505.68,1716.08,1390.32,1787.22,1319.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce9153491dcc30ac4b6eef15ececc104.svg";
export { ForwardRef as ReactComponent };